import styled from "styled-components"
import { Button, Card, Col, List, Row, Space, Typography } from "antd"
const { Title } = Typography
export const MobileCommentRating = styled.div`
  @media (max-width: 428px) {
    margin-left: 52px;
  }
  @media (max-width: 390px) {
    margin-left: 52px;
  }
  @media (max-width: 360px) {
    margin-left: 52px;
  }
`
export const Responsive = styled.div`
  @media (max-width: 428px) {
    .d-flex.justify-content-flex-start {
      display: inline-table !important;
      .mr-10.div-logo-product {
        img {
          width: 83% !important;
        }
        .div-hover {
          width: 83%;
        }
      }
      .content-product {
        width: 342px;
        .d-flex.justify-content-flex-start {
          display: flex;
        }
      }
    }
  }
  @media (max-width: 412px) {
    .d-flex.justify-content-flex-start {
      display: inline-table !important;
      .mr-10.div-logo-product {
        img {
          width: 72% !important;
        }
        .div-hover {
          width: 72%;
        }
      }
      .content-product {
        width: 342px;
        .d-flex.justify-content-flex-start {
          display: flex;
        }
      }
    }
  }
  @media (max-width: 390px) {
    .d-flex.justify-content-flex-start {
      display: inline-table !important;
      .mr-10.div-logo-product {
        img {
          width: 82% !important;
        }
        .div-hover {
          width: 83%;
        }
      }
      .content-product {
        width: 342px;
        .d-flex.justify-content-flex-start {
          display: flex;
        }
      }
    }
  }
  @media (max-width: 360px) {
    .d-flex.justify-content-flex-start {
      display: inline-table !important;
      .mr-10.div-logo-product {
        img {
          width: 71% !important;
        }
        .div-hover {
          width: 71%;
        }
      }
      .content-product {
        width: 315px;
        .d-flex.justify-content-flex-start {
          display: flex;
        }
      }
    }
  }
`

export const StyleCourse = styled.div`
  .ant-pagination {
    display: flex !important;
  }

  .mgt36 {
    margin-top: 36px;
  }
  .mgl11 {
    margin-left: 11px;
  }
  .list-title {
    font-weight: 600;
    font-size: 24px;
    color: #154398;
    margin-bottom: 24px;
  }
  .search-form {
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
      border-radius: 4px !important;
    }

    .ant-input {
      border-radius: 4px;
    }
    .ant-btn {
      border-radius: 4px !important;
    }
  }
`

export const RatingRateCourse = styled.div`
  .title-rating {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 24px;
    span {
      margin-right: 8px;
    }
    div {
      font-weight: 600;
      font-size: 20px;
      color: #212529;
    }
  }
`
export const RatingProductWrapper = styled.div`
  border: solid #dddddd;
  border-width: 0 1px 1px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .image-review {
    overflow: auto;
    width: 100%;
  }

  .image-box {
    width: 100px;
    min-width: 100px;
    height: 100px;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 0px;
    border: 1px solid rgba(131, 131, 131, 0.1);
  }
  .ant-pagination {
    display: flex;
  }
  .ant-tabs-nav {
    margin: 0px;
  }
  .ant-tabs-content-holder {
    display: none;
  }
  .ant-spin-nested-loading {
    width: 100%;
  }
  .border {
    border: 1px solid #dddddd;
    display: flex;
  }

  .averaging {
    padding: 10px 0 20px;
    .anticon {
      font-size: 26px;
    }
    .ant-rate {
      font-size: 0 !important;
    }
  }

  .box-option {
    display: flex;
    align-items: center;
    border: 0 solid #ddd;
    border-left-width: 1px;
    padding: 15px 10px;
  }

  .progress-rating {
    .ant-rate {
      min-width: 130px;
    }
  }

  .time-comment {
    font-size: 12px;
    color: #666666;
    padding-top: 15px;
  }

  .content-comment {
    font-size: 14px;
    color: #000000;
    padding: 15px 0;
  }

  .username {
    font-size: 12px;
    color: #000000;
  }

  .btn-see-more {
    margin: 20px 0;
    color: #154398;
    border: 1px solid #154398;
  }
`
export const StyleCourseSummary = styled.div`
  display: flex !important;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
  .course-item {
    position: relative;

    .percent-discount {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 90px;
      height: 30px;
      padding: 5px 8px;
      background: #ed1117;
      opacity: 0.9;
      border-radius: 10px 0px 0px 10px;
      font-weight: 600;
      font-size: 12px;
      color: #ffffff;

      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .space17 {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .course-content {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(21, 67, 152, 0.1);
    border-radius: 8px;
    width: 100%;
    padding: 20px;
    .service-package {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .package {
        font-weight: 600;
        font-size: 16px;
        color: #154398;
      }
      .targets {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        span {
          margin-right: 8px;
        }
        div {
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }
      }
    }
    .uper {
      text-transform: uppercase;
    }
    .capital {
      text-transform: capitalize;
    }
    &-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 150%;
      color: #154398;
    }
    .course-rate {
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      ul {
        margin-right: 10px;
      }
    }
    &-des {
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
    }

    .course-content-teacher {
      font-weight: 600;
      font-size: 14px;
      color: #212529;
    }
    .course-detail {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px dashed #dddddd;
      div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 27px;
        span {
          margin-right: 8px;
        }
      }
    }
    .course-price {
      .course-price-discount {
        font-weight: 600;
        font-size: 20px;
        color: #ed1117;
        margin-right: 8px;
      }
      .course-price-root {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-decoration-line: line-through;

        color: #666666;
      }
    }
  }
`
export const StyleDetailCourse = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .course-title {
    font-weight: 600;
    font-size: 16px;
    color: #154398;
    margin-bottom: 24px;
  }
  .course-content {
    font-weight: 400;
    font-size: 14px;
    color: #212529;
    margin-bottom: 8px;
  }
  .course-content-detail {
    ul {
      margin-bottom: 24px;
      li {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        list-style-type: none;
        margin-top: 8px;
        span {
          margin-right: 8px;
        }
      }
    }
  }
  .add-cart-btn {
    button {
      border: none;
      outline: none;
      justify-content: center;
      width: 311px;
      height: 56px !important;
      background: #00c590;
      border-radius: 4px !important;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
      color: #ffffff;
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        :first-child {
          margin-right: 10px;
        }
      }
    }
  }
`
export const StyleContentCourse = styled.div`
  .ant-collapse-header-text {
    font-weight: 600;
    font-size: 16px;
    color: #154398;
  }
  .rotate {
    transform: rotate(90deg) !important;
    top: 25% !important;
  }
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 24px 24px 0px 24px !important;
    background-color: #fff !important;
  }
  .course-video {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 24px;
    .video-name {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }

  .margintop {
    margin-top: 24px;
  }
  .content-title {
    font-weight: 600;
    font-size: 20px;
    color: #212529;
    span {
      margin-right: 8px;
    }
  }
`
export const StyleCourseTeacher = styled.div`
  .teacher-title {
    font-weight: 600;
    font-size: 20px;
    color: #212529;
    span {
      margin-right: 8px;
    }
  }
  .teacher-list {
    margin-top: 24px;
  }

  .course-teacher-item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0px;
    .course-teacher-left {
      position: relative;
      img {
        border-radius: 100%;
        border: 3px solid #ffffff;
        background-color: #ffffff;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
        object-fit: cover;
        z-index: 1;
      }
    }
    .course-teacher-right {
      margin: 8px;
      .teacher-information {
        padding: 8px;
        margin-left: -50px !important;
        background: #ffffff;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

        border-radius: 0px 0px 20px 20px;
        padding-left: 50px;
        z-index: 10;
        .teacher-name {
          font-weight: 700;
          font-size: 14px;
          color: #154398;
          font-style: italic;
        }
        .teacher-position {
          font-weight: 400;
          font-size: 10px;
          color: #154398;
          font-style: italic;
          color: #154398;
        }
        .teacher-rate {
          display: flex;
          justify-content: flex-start;
          align-items: flex-end;
          div {
            ul {
              line-height: 20px;
            }
            .anticon-star {
              font-size: 10px;
            }
          }
          .teacher-rate-number {
            font-weight: 600;
            margin-left: 4px;
            margin-bottom: 2px;
            font-size: 10px;
            color: #154398;
          }
        }
      }
    }
  }

  .teacher-in-course {
    font-weight: 600;
    font-size: 10px;
    color: #00c590;
  }
`
export const StyleIntroduceCourse = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #212529;
  .introduce-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;
    span {
      margin-right: 10px;
    }
    div {
      font-weight: 600;
      font-size: 20px;
      color: #212529;
    }
  }
  .intro {
    display: flex;
    justify-content: center;
    align-items: center;
    .roadside {
      display: flex;
      justify-content: center;
      align-items: center;
      div {
        width: 4px;
        height: 84px;
        background: #fff501;
      }
    }
  }
  .title {
    font-weight: 600;
    font-size: 16px;
    color: #212529;
    margin-top: 24px;
  }

  .magin0 {
    margin-top: 0px;
  }
  ul {
    margin-left: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
`

export const StylePreferentialTime = styled.div`
  padding: 1px 10px;
  .times {
    width: 24px;
    height: 24px;
    background: #ed1117;
    border-radius: 4px;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    padding: 1px 3px;
  }
`
export const StyleDetailCourse2 = styled.div`
  .course-detail {
    .course-title {
      font-weight: 600;
      font-size: 24px !important;
      color: #154398;
      margin: 30px 0px 24px 0px;
    }
    .course-rate {
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      margin-bottom: 24px;
      ul {
        margin-right: 10px;
        svg {
          width: 17px;
          height: 17px;
        }
      }
    }
    .course-teacher {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 50px;
      img {
        border-radius: 100%;
        border: 3px solid #ffffff;
        background-color: #ffffff;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
        object-fit: cover;
        z-index: 1;
      }
      .course-teacher-right {
        margin: 8px;
        .teacher-information {
          padding: 8px;
          height: 51px;
          margin-left: -50px !important;
          background: #ffffff;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
          border-radius: 30px 0px 20px 30px;
          padding-left: 50px;
          z-index: 10;
          .teacher-name {
            font-weight: 700;
            font-size: 14px;
            color: #154398;
            font-style: italic;
          }
          .teacher-position {
            font-weight: 400;
            font-size: 10px;
            color: #154398;
            font-style: italic;
          }
        }
      }
    }
  }
  .course-register {
    width: 100%;
    border: 1px solid #dddddd;
    border-radius: 8px;
    margin-top: 30px;
    padding: 24px;

    font-weight: 400;
    font-size: 12px;
    color: #212529;

    .course-price {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .discount-price {
        font-weight: 600;
        font-size: 24px;
        color: #ed1117;
        margin-right: 9px;
      }
      .root-price {
        font-weight: 400;
        font-size: 14px;
        color: #777777;
      }
    }
  }
  .course-time-discount {
    margin-top: 14px;
    margin-bottom: 24px;
    align-items: center;
  }
  .register-btn {
    align-items: center;
    width: 100%;
    height: 56px !important;
    background: #154398;
    border-radius: 4px;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    margin-top: 24px;
  }

  .add-btn {
    align-items: center;
    width: 100%;
    height: 56px !important;
    background: #00c590;
    border-radius: 4px;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    margin-top: 15px;
    margin-bottom: 24px;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .information {
    .infor-title {
      font-weight: 600;
      font-size: 14px;
      color: #212529;
    }
  }
`

export const ProductWrapper = styled.div`
  .card-wrapper {
    display: flex;
    flex-direction: column;
  }

  .ant-form-item-label > label {
    font-weight: 400;
    font-size: 14px;
    color: #838383;
  }

  .border-image {
    border: 2px solid #dddddd;
    border-radius: 6px;
    :hover {
      cursor: pointer;
      box-shadow: 0px 0px 20px rgba(21, 67, 152, 0.1);
    }
  }

  .product-title {
    font-weight: 600;
    font-size: 24px;
    color: #154398;
    padding: 20px 0;
  }

  /* .product-info {
    padding-bottom: 20px;
    font-weight: 600;

    &--2 {
      padding-top: 20px;
      color: #154398;
      cursor: pointer;
      :hover {
        color: #ed1117;
      }
    }
  } */

  .price {
    color: #ed1117;
    font-weight: 600;
  }

  .ant-rate {
    font-size: 0px;
  }
`

export const ListProductWrapper = styled.div`
  margin-top: 20px;
  .card-wrapper {
    display: flex;
    flex-direction: column;
  }

  .border-image {
    border: 2px solid #dddddd;
    border-radius: 6px;
    :hover {
      cursor: pointer;
      box-shadow: 0px 0px 20px rgba(21, 67, 152, 0.1);
    }
  }

  .product-title {
    font-weight: 600;
    font-size: 24px;
    color: #154398;
    padding: 20px 0;
  }

  .product-info {
    margin-bottom: 20px;
    font-weight: 600;

    &--2 {
      padding-top: 20px;
      color: #154398;
      cursor: pointer;
      :hover {
        color: #ed1117;
      }
    }

    &--3 {
      display: flex;

      div {
        font-weight: 400;
        font-size: 14px;
      }
    }
  }

  .price {
    color: #ed1117;
    font-weight: 600;
  }

  .ant-rate {
    font-size: 0px;
  }
`

export const RelatedProductWrapper = styled.div`
  background: "#F7F7F7";
  border: 3px solid #f7f7f7;
  .title-type-2 {
    padding-bottom: 10px;
  }
  .ant-divider-horizontal {
    margin: 24px 0 0;
  }
  .emty {
    padding-bottom: 16px;
    background: #f7f7f7;
    .ant-empty {
      background: #f7f7f7;
      margin: 0px;
    }
  }
  .title-header {
    border-bottom: 2px solid #7f96c1;
    padding-bottom: 20px;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: #ffffff;
  }

  .title-border {
    content: "";
    width: 20px;
    height: 4px;
    color: #000000;
    position: absolute;
  }

  .box-content {
    background-color: #f7f7f7;
    padding: 20px;
    /* width: 259px; */
  }

  .img-relatived {
    width: 80px;
    height: 80px;
    background-color: #ffffff;
  }

  .item-title {
    font-weight: 600;
    font-size: 12px;
    color: #000000;
  }

  .item-price {
    font-weight: 400;
    font-size: 12px;
    color: #ed1117;
  }
`

export const InforWrapper = styled.div`
  @media (max-width: 428px) {
    .d-flex.justify-content-flex-start.align-items-flex-start {
      display: inline-block !important;
      .buy-box {
        width: 100% !important;
        .ant-space.ant-space-horizontal.ant-space-align-center {
          margin-left: -22px;
          display: block;
          .buy-product {
            width: 103%;
          }
          .buy-product2.mt-10 {
            width: 100%;
            div {
              width: 100% !important;
            }
          }
        }
      }
    }
  }

  @media (max-width: 390px) {
    .d-flex.justify-content-flex-start.align-items-flex-start {
      display: inline-block !important;
      .buy-box {
        width: 100% !important;
        .ant-space.ant-space-horizontal.ant-space-align-center {
          margin-left: -22px;
        }
      }
    }
  }

  .div-logo-product {
    display: flex;
    justify-content: center;
    align-items: center;
    /* border-radius: 100%; */
    overflow-y: hidden;
    position: relative;

    :hover {
      img {
        transform: translateY(calc((-100% + 30vh)));
      }
      .div-hover {
        display: flex;
      }
    }
    img {
      width: 100%;
      object-fit: contain;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      transition: all 3s ease-in-out;
    }
  }
  .img-product {
    min-width: 270px;
    height: 250px;
    border-radius: 10px;
    border: 0.5px solid #e9e9e9;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .infor-product {
    @media (max-width: 480px) {
      .header-title {
        width: 100% !important;
      }
    }

    .header-title {
      width: 63%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      max-width: 100%;
      img {
        width: 200px;
        height: 100px;
        border-radius: 100%;
        margin-right: 16px;
      }
      div {
        font-weight: 600;
        font-size: 24px;
        color: #000000;
      }
    }

    .price {
      font-weight: 400;
      font-size: 36px;
      margin-top: 6px;
      color: #ed1117;
    }
  }

  .bx-div {
    box-shadow: rgb(21 66 151 / 10%) 0px 0px 30px;
  }
  .btn-add-card {
    div div {
      display: flex;
      justify-content: center !important;
      justify-content: center !important;
    }
    :hover {
      background: #154398 !important;
      box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.2);
      border: none;
      color: #fff;
      div div span {
        color: #fff !important;
      }
      div div span svg path {
        fill: #fff;
      }
    }
  }
  .btn-buy {
    :hover {
      background: #154398 !important;
      color: #fff !important;
      box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.2);
      border: none;
    }
  }
  .buy-product {
    width: 150px;
    .ant-btn {
      width: 100%;
      height: 50px !important;
    }
  }
  .buy-product2 {
    width: 350px;
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    div {
      width: 172px;
      .ant-btn {
        width: 100%;
        height: 42px !important;
      }
    }
  }
  @media only screen and (max-width: 390px) {
    .buy-product .ant-btn {
      width: 75%;
      height: 43px !important;
    }
    .img-infor {
      padding-left: 15px;
    }
    .buy-product {
      width: 150px;
      .ant-btn {
        width: 100% !important;
        height: 50px !important;
      }
    }
  }
  @media only screen and (max-width: 480px) {
    #img-size {
      width: 100% !important;
    }
    img {
      width: 110px !important;
    }
    .infor-product .header-title div {
      font-size: 15px;
    }
    .buy-product .ant-btn {
      /* width: 75%; */
      height: 45px !important;
    }
    .ant-rate {
      font-size: 14px;
    }

    .progress-rating .ant-rate {
      min-width: 0px;
    }
    .buy-product {
      width: 150px;
      .ant-btn {
        width: 100%;
        height: 50px;
      }
    }
  }
`

export const RelatedInfor = styled.div`
  padding-bottom: 20px;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: solid #dddddd;
  border-width: 0 0px 0px;
  padding: 20px;

  ul > li {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    margin-left: 20px;
  }

  .title {
    font-weight: 600;
    font-size: 16px;
    color: #ed1117;
  }

  .content {
    font-weight: 400;
    font-size: 14px;
  }

  .btn-see-more {
    margin: 20px 0;
    color: #154398;
    border: 1px solid #154398;
  }
`

export const InforProductWrapper = styled.div`
  max-width: 800px;
  padding: 0 10px;
  .bx-div {
    box-shadow: rgb(21 66 151 / 10%) 0px 0px 30px;
  }
  .btn-add-card {
    div div {
      display: flex;
      justify-content: center !important;
      justify-content: center !important;
    }
    :hover {
      background: #154398 !important;
      box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.2);
      border: none;
      color: #fff;
      div div span {
        color: #fff !important;
      }
      div div span svg path {
        fill: #fff;
      }
    }
  }
  .btn-buy {
    :hover {
      background: #154398 !important;
      color: #fff !important;
      box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.2);
      border: none;
    }
  }
  .input-no-border {
    margin: 0px 15px;
  }
  .ant-rate {
    font-size: 0px;
  }

  .ant-radio-button-wrapper {
    margin: 0 10px;
  }

  .ant-form-horizontal .ant-form-item-label {
    align-items: center;
    display: flex;
  }

  .ant-input,
  .ant-input-affix-wrapper {
    border-radius: 4px;
  }

  .react-favor svg {
    margin: 0 20px;
  }

  .truck {
    margin-right: 10px;
    &--none {
      svg {
        visibility: hidden;
      }
    }
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .header-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 200px;
      height: 200px;
      border-radius: 100%;
      margin-right: 16px;
    }
    div {
      font-weight: 600;
      font-size: 24px;
      color: #000000;
    }
  }

  .option-title {
    font-size: 14px;
    font-weight: 400;
    &-1 {
      font-weight: 600;
    }
  }

  .price {
    font-weight: 400;
    font-size: 36px;
    margin-top: 6px;
    color: #ed1117;
  }

  .border-line {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    :hover {
      border-radius: 4px;
    }
  }

  .diable-button {
    cursor: not-allowed !important;
    opacity: 0.7;
  }
  .discount {
    display: flex;

    &--price {
      font-weight: 400;
      font-size: 16px;
      text-decoration-line: line-through;
      color: #666666;
    }

    &--percent {
      color: white;
      font-weight: 400;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      padding: 3px 4px;
      width: 49px;
      height: 25px;
      background: #f88c00;
      border-radius: 4px;
    }
  }
  @media only screen and (max-width: 480px) {
    .option-title {
      margin-left: 0;
      margin-top: 0;
    }
  }
`

export const ListImageWrapper = styled.div`
  .slick-initialized .slick-slide {
    padding: 10px 5px;
  }
  .icon-media-large {
    svg {
      width: 40px;
      height: 40px;
    }
  }
  .box-image {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80px;
    width: 100%;
  }
  .border-img {
    border: 2px solid #dddddd;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
  }

  .image-pro {
    :hover {
      box-shadow: 0px 0px 20px rgba(21, 67, 152, 0.1);
    }
  }

  .info-pro {
    display: flex !important;
    flex-direction: column;
    align-items: center;
  }
`
export const ImgSize = styled.div`
  @media (max-width: 428px) {
    img {
      height: auto;
    }
  }
  @media (max-width: 390px) {
    img {
      height: auto;
    }
  }
`
export const RatingCourseWrapper = styled.div`
  border: solid #dddddd;
  border-width: 0px 0px 1px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;

  .rating-product {
    width: 100%;
    box-sizing: border-box;

    .rate {
      .anticon svg {
        font-size: 50px;
      }
    }
  }

  .image-review {
    overflow: auto;
    width: 100%;
  }

  .image-box {
    width: 100px;
    min-width: 100px;
    height: 100px;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 0px;
    border: 1px solid rgba(131, 131, 131, 0.1);
  }

  .ant-pagination {
    display: flex;
  }

  .ant-tabs-nav {
    margin: 0px;
  }

  .ant-tabs-content-holder {
    display: none;
  }

  .ant-spin-nested-loading {
    width: 100%;
  }

  .border-bottom {
    border: 1px solid #dddddd;
    border-width: 0 0px 1px;
    display: flex;
  }

  .border-bottom1 {
    border: 1px solid #dddddd;
    border-width: 0 0px 1px;
    display: flex;
  }

  .averaging {
    padding: 10px 0 20px;
    .anticon {
      font-size: 26px;
    }
    .ant-rate {
      font-size: 0 !important;
    }
  }

  .averagingmobi {
    padding: 10px 0 20px;
    .anticon {
      font-size: 23px;
    }
    .ant-rate {
      font-size: 0 !important;
    }
  }

  .averagingmobi1 {
    margin-top: 0 !important;
  }

  .box-option {
    display: flex;
    align-items: center;
    border: 0 solid #ddd;
    border-left-width: 1px;
    padding: 15px 10px;
  }

  .progress-rating {
    .ant-rate {
      min-width: 130px;
    }
  }

  .time-comment {
    font-size: 12px;
    color: #666666;
    padding-top: 15px;
  }

  .content-comment {
    font-size: 14px;
    color: #000000;
    padding: 15px 0;
  }

  .username {
    font-size: 12px;
    color: #000000;
    font-weight: 600;
  }

  .btn-see-more {
    margin: 20px 0;
    color: #154398;
    border: 1px solid #154398;
  }

  /* Responsive cho mobile */
  @media only screen and (max-width: 576px) {
    padding: 8px;

    .rating-product {
      padding: 12px;
    }

    /* Nút lọc đánh giá */
    .filter-buttons {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      gap: 4px;
      padding-bottom: 8px;

      .ant-btn {
        padding: 4px 8px;
        font-size: 12px;
        height: 32px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        white-space: nowrap;
      }

      .ant-rate {
        font-size: 12px !important;
        margin-right: 4px;
      }
    }

    /* Form đánh giá */
    .ant-form {
      .ant-form-item {
        margin-bottom: 12px;
      }

      .ant-form-item-label {
        padding-bottom: 4px;
        label {
          font-size: 14px;
        }
      }

      .ant-rate {
        font-size: 16px !important;
      }

      .ant-input-textarea {
        font-size: 14px;
        padding: 8px;
      }

      .ant-btn {
        font-size: 14px;
        height: 36px;
        padding: 4px 12px;
        border-radius: 6px;
      }
    }

    /* Danh sách bình luận */
    .ant-list {
      .ant-list-item {
        padding: 8px 0;
      }

      .ant-list-item-meta {
        .ant-list-item-meta-title {
          .ant-rate {
            font-size: 14px !important;
          }
        }

        .ant-list-item-meta-description {
          font-size: 12px;
          line-height: 1.4;
        }
      }
    }
  }

  @media only screen and (max-width: 428px) {
    padding: 4px;

    .filter-buttons {
      gap: 2px;

      .ant-btn {
        font-size: 11px;
        height: 28px;
        padding: 4px 6px;
      }

      .ant-rate {
        font-size: 10px !important;
      }
    }

    .ant-form {
      .ant-form-item-label label {
        font-size: 12px;
      }

      .ant-rate {
        font-size: 14px !important;
      }

      .ant-btn {
        font-size: 12px;
        height: 32px;
      }
    }
  }

  @media only screen and (max-width: 390px) {
    .filter-buttons {
      .ant-btn {
        font-size: 10px;
        height: 26px;
        padding: 4px 5px;
      }

      .ant-rate {
        font-size: 9px !important;
      }
    }
  }
`

export const RatingMobile = styled.div`
  @media (max-width: 428px) {
    .border-bottom {
      display: block !important;
      .rating-text {
        margin-left: 22px !important;
        .rating-number {
          display: flex;
          gap: 34px;
        }
      }
      .progress-rating {
        margin-left: 19px;
      }
    }
  }
  @media (max-width: 390px) {
    .border-bottom {
      display: block !important;
      .rating-text {
        margin-left: 22px !important;
        .rating-number {
          display: flex;
          gap: 34px;
        }
      }
      .progress-rating {
        margin-left: 19px;
      }
    }
  }
  @media (max-width: 360px) {
    .border-bottom {
      display: block !important;
      .rating-text {
        margin-left: 22px !important;
        .rating-number {
          display: flex;
          gap: 34px;
        }
      }
      .progress-rating {
        margin-left: 3px;
      }
    }
  }
`
export const CardInformation = styled.div`
  border: solid #dddddd;
  border-width: 1px;
  border-radius: 8px;
  padding: 16px;
`

export const FeatureContainer = styled.div`
  padding: 16px;
  border-radius: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ImageContainer = styled.div`
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
`

export const StyledList = styled(List)`
  .ant-list-item {
    border: none !important;
  }
`

export const StyledUl = styled.ul`
  margin-bottom: 0;
  font-size: 20px;
  line-height: 1.5;
  padding-left: 24px;

  li {
    font-size: 16px;
  }
`

export const FeatureTitle = styled(Title)`
  &.ant-typography {
    margin: 0;
    color: #db563a;
  }
`

export const DetailWrapper = styled.div`
  .col-border {
    border-left: 1px solid #ddd;
  }
`
export const OptionsWrapper = styled.div`
  padding-left: 15px;
  .scroll {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
  }
  .title {
    font-weight: 600;
    font-size: 16px;
    text-transform: uppercase;

    color: #154398;
    margin-bottom: 20px;
  }

  .option-content {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    padding-right: 12px;
    color: #666666;
  }

  .option-title {
    cursor: pointer;
    /* flex: 1; */
    &:hover {
      .option-content {
        font-weight: 600;
      }
    }
  }

  .list-options {
    display: flex;
    justify-content: space-between;
  }
`

export const ServiceWrapper = styled.div`
  .list-service {
    display: flex;
    flex-flow: row wrap;
    align-content: space-between;
    justify-content: center;
  }

  .service-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    width: 188px;
    min-width: 188px;
    padding: 31px 0 45px;
    margin: 15px;
    height: 220px;
    cursor: pointer;
    box-shadow: 0px 0px 30px rgba(21, 67, 152, 0.1);

    :hover {
      box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
        rgba(0, 0, 0, 0.22) 0px 10px 10px;
    }
  }

  .bg-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 74px;
    width: 74.6px;
    height: 74.6px;
    background: linear-gradient(207.16deg, #1f7874 20.09%, #2a418a 90.42%);
  }

  .service-title {
    text-align: center;
    margin-top: 24px;
    font-weight: 600;
    font-size: 16px;
    color: #154398;
  }
`
export const StyleSellingProductItem = styled.div`
  .pv-16 {
    padding: 0px 16px;
  }
  .item__img {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 4px;
  }
  .item-title {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    color: #154398;
    margin: 10px auto 0px 0px;
  }
  .item-price {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #ed1117;
  }
`
export const StyleWaterTest = styled.div`
  .service-row {
    padding-left: 70px;
    padding-right: 70px;
  }
  .service {
    position: relative;
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(21, 67, 152, 0.1);
    border-radius: 8px;
    padding: 37px;
    margin-top: 23px;
    margin-bottom: 25px;

    ::after {
      content: "";
      display: block;
      width: 100%;
      height: 0px;
      background: linear-gradient(90deg, #154297 0%, #ed1e24 100%);
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    :hover::after {
      height: 4px;
    }
    :hover {
      box-shadow: 0px 2px 20px rgba(21, 67, 152, 0.2);
      border-bottom: 4px solid linear-gradient(90deg, #154297 0%, #ed1e24 100%);
    }
    img {
      margin-bottom: 24px;
      width: 82px;
      height: 82px;
      width: 100%;
    }
    .service-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      text-align: center;
      color: #154398;
    }
  }
`

export const CardDetail = styled.div`
  border: solid #dddddd;
  border-width: 1px;
  border-radius: 8px;
  padding: 16px;
  max-width: 300px;

  @media (max-width: 576px) {
    max-width: 100%;
    padding: 8px;
  }
`

export const ThumbnailContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 8px;
  max-width: 300px;

  button {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid #ccc;
    background-color: #fff;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      background-color: #f0f0f0;
    }

    @media (max-width: 576px) {
      width: 20px;
      height: 20px;
      font-size: 12px;
    }
  }

  @media (max-width: 576px) {
    max-width: 100%;
    gap: 4px;
  }
`

export const Thumbnail = styled.img`
  width: 50px;
  height: 50px;
  cursor: pointer;
  border-radius: 5px;
  border: ${({ active }) => (active ? "2px solid red" : "1px solid #ccc")};
  transition: border 0.3s ease;
  &:hover {
    border: 2px solid red;
  }
  @media (max-width: 576px) {
    width: 30px;
    height: 30px;
  }
`

export const ImageNav = styled(Button)`
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  &:hover {
    color: red;
  }
`

export const StyledProductDetail = styled.div`
  @media (max-width: 576px) {
    padding: 8px;

    .ant-row {
      margin-top: 8px !important;
    }

    .ant-col {
      padding: 0 4px !important;
    }

    .ant-btn {
      font-size: 14px !important;
      height: 36px !important;
    }

    .ant-typography {
      font-size: 16px !important;
    }

    .ant-list-item {
      padding: 8px 0 !important;
    }

    .ant-rate {
      font-size: 14px !important;
    }
  }
  @media (max-width: 428px) {
    .repo-mobile {
      display: none;
    }
    .ant-col.ant-col-18 {
      max-width: 100% !important;
    }
    .minw {
      text-align: justify;
    }
  }
  @media (max-width: 390px) {
    .repo-mobile {
      display: none;
    }
    .ant-col.ant-col-18 {
      max-width: 100% !important;
    }
    .ant-layout {
      text-align: justify;
    }
    .ant-typography {
      font-size: 14px !important;
    }

    .ant-btn {
      font-size: 12px !important;
      height: 32px !important;
    }
  }

  .div-sticky {
    box-shadow: rgb(21 66 151 / 10%) 0px 0px 30px;
    margin-top: 16px;
    background: #fff;
    .ant-tabs-nav {
      margin: 0px;
    }
  }

  .div-sticky2 {
    box-shadow: rgb(21 66 151 / 10%) 0px 25px 30px;
    background: #fff;
  }
  .bs-div-product {
    box-shadow: rgb(21 66 151 / 10%) 0px 0px 30px;
    padding: 16px;
  }
  .course-register {
    width: 100%;
    border-radius: 8px;

    font-weight: 400;
    font-size: 12px;
    color: #212529;
    .introduce-company {
      /* background: #000; */
      width: 100%;
      color: #fff;
      padding: 24px;
      background: linear-gradient(236deg, #f2709c, #faaca8, #ff9472);
      b {
        font-size: 20px;
      }
    }
    .course-price {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .discount-price {
        font-weight: 600;
        font-size: 24px;
        color: #ed1117;
        margin-right: 9px;
      }
      .root-price {
        font-weight: 400;
        font-size: 14px;
        color: #777777;
      }
    }
  }
  .course-time-discount {
    margin-top: 14px;
    margin-bottom: 24px;
    align-items: center;
  }
  .register-btn {
    align-items: center;
    width: 100%;
    height: 56px !important;
    background: #6190e8;
    border: none !important;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    margin-top: 24px;
  }

  .add-btn {
    align-items: center;
    width: 100%;
    height: 56px !important;
    background: #00c590;
    border-radius: 4px;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    margin-top: 15px;
    margin-bottom: 24px;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`
export const ViewPDFStyle = styled.div`
  .pdf-container {
    height: auto !important;
    border: none;
  }
  .ant-modal-body {
    padding: 0;
    overflow: hidden hidden;
  }
  .ant-modal-header {
    &::after {
      content: unset;
    }
  }
  .pdf-container {
    height: calc(100vh - 20px);
    overflow-y: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .rpv-default-layout__toolbar {
      position: sticky;
      top: 0;
    }
  }
`
export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  align-items: center;
  width: 100%;
  margin: 0;

  @media (max-width: 1440px) {
    grid-template-columns: repeat(2, 1fr);
    max-width: 600px;
  }

  @media (max-width: 576px) {
    grid-template-columns: repeat(2, 1fr);
    max-width: 300px;
  }
`

export const CardProduct = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: 576px) {
    display: flex;
    flex-direction: column;
    align-items: start;
  }
`
export const CardCategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: "100%";
  position: relative;

  @media (max-width: 576px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

export const CardStyled = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  flex-grow: 1;
  position: relative;
  background:linear-gradient(rgb(253, 0, 0) 0%,rgb(16, 58, 136) 100%);
  width: 300px;
  height: auto;
  overflow: hidden;

  &::after {
    content: "";
    background-image: linear-gradient(90deg, #154398 0%, #e4353a 100%);
    display: block;
    height: 0;
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
    transition: height 0.2s ease-in-out;
  }

  &:hover {
    border: 1px solid transparent;
    box-shadow: 0px 0px 15px rgba(0, 68, 255, 0.6);
  }

  .card-image {
    width: 100%;
    height: 240px;
    background-color: #d1cfd4;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.3s ease-in-out;
  }

  img {
    width: 100%;
    max-height: 100%;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .ant-card-body {
    width: 100%;
    padding: 0;
  }

  .card-content {
    padding: 12px;
    text-align: start;
    color: white;
  }

  .card-title {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
  }

  .card-description {
    font-size: 12px;
    color: #ddd;
  }

  .card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }

  .card-rating {
    display: flex;
  }

  .card-sold {
    font-size: 12px;
    margin-left: 5px;
  }

  @media (max-width: 768px) {
    width: 240px;
    height: 300px;
    .card-image {
      height: 160px;
      object-fit: contain;
    }
  }

  @media (max-width: 576px) {
    width: 180px;
    height: 300px;
    .card-image {
      width: 100%;
      height: 150px;
      display: flex;
      object-fit: contain;
      background-color: #d1cfd4;
      justify-content: center;
      align-items: center;
      transition: transform 0.3s ease-in-out;
    }
    .card-footer {
      flex-direction: column;
      align-items: flex-start;
    }
    .card-sold {
      padding-top: 8px;
    }
  }
`

export const CardCategoryStyled = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  flex-grow: 1;
  justify-content: center;
  background:linear-gradient(rgb(253, 0, 0) 0%,rgb(16, 58, 136) 100%);
  width: 300px;
  height: 280px;
  overflow: visible;

  &::after {
    content: "";
    background-image: linear-gradient(90deg, #154398 0%, #e4353a 100%);
    display: block;
    height: 0;
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
    transition: height 0.2s ease-in-out;
  }

  &:hover {
    border: 1px solid transparent;
    box-shadow: 0px 0px 15px rgba(0, 68, 255, 0.6);
  }

  .card-image {
    width: 100%;
    height: 225px;
    object-fit: contain;
    display: flex;
    background-color: #d1cfd4;
    justify-content: center;
    align-items: center;
    transition: transform 0.3s ease-in-out;
  }

  img {
    width: 100%;
    max-height: 100%;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .ant-card-body {
    width: 100%;
    padding: 0;
  }

  .card-content {
    padding: 12px;
    color: white;
    text-align: center;
  }

  .card-title {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }

  @media (max-width: 576px) {
    width: 150px;
    height: 150px;
    .card-image {
      height: 96px;
      object-fit: contain;
    }
  }
`

export const NavigationButton = styled.button`
  display: ${({ hide }) => (hide ? "none" : "block")};
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background:linear-gradient(90deg, #154297 0%, #ed1e24 100%);
  border: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 30;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 0 15px rgba(67, 28, 104, 0.7);

  &:hover {
    background::linear-gradient(90deg,rgb(0, 87, 248) 0%,rgb(124, 14, 17) 100%);
    box-shadow: 0 0 20px rgba(228, 160, 160, 0.7);
  }

  ${props =>
    props.left
      ? `
    left: -10px;
  `
      : `
    right: -60px;
  `}

  @media (max-width: 1440px) {
    width: 30px;
    height: 30px;
    left: ${props => (props.left ? "15px" : "auto")};
    right: ${props => (props.right ? "-5px" : "auto")};

    svg {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
    left: ${props => (props.left ? "-10px" : "auto")};
    right: ${props => (props.right ? "-10px" : "auto")};

    svg {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 576px) {
    width: 30px;
    height: 30px;
    left: ${props => (props.left ? "-5px" : "auto")};
    right: ${props => (props.right ? "-20px" : "auto")};

    svg {
      width: 16px;
      height: 16px;
    }
  }
`

export const FilterWrapper = styled.div`
  @media (max-width: 1024px) {
    display: none;
  }
`

export const MobileFilterButton = styled.div`
  display: none;
  @media (max-width: 1024px) {
    display: block;
  }
`

export const LayoutProductPage = styled.div`
  width: 100%;
  padding: 0 16px;
  max-width: 1600px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0 8px;
  }
`
